import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetActiveBankAccounts = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/bank-accounts/active`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load active bank accounts.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetBankAccounts = async (params?: {
  page?: number;
  limit?: number;
  search?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/bank-accounts`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load bank accounts.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetBankAccountsWithDeleted = async (params?: {
  page?: number;
  limit?: number;
  search?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/bank-accounts/with-deleted`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load bank accounts.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const CreateBankAccount = async (data: any): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/bank-accounts/create`, data);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to create bank account.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const UpdateBankAccount = async (data: any): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/bank-accounts/update`, data);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to update bank account.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const DeleteBankAccount = async (id: string): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/bank-accounts/delete`, { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete bank account.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetBankTransactions = async (
  bank_account_id: string,
  params?: { page?: number; limit?: number }
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/bank-accounts/transactions`, {
      params: { bank_account_id, ...params },
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load bank transactions.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const CreateBankTransaction = async (data: any): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/bank-accounts/transactions/create`, data);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to create manual transaction.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};
